import {Component, forwardRef, Input} from '@angular/core';
import {FileTypes} from '../../utils/type-checker';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {FileManagerService} from 'src/app/services/file-manager/file-manager.service';
import {MAX_FILE_SIZE} from '../../utils/constants';

@Component({
  selector: 'app-image-uploader',
  templateUrl: './image-uploader.component.html',
  styleUrls: ['./image-uploader.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImageUploaderComponent),
      multi: true,
    },
  ],
})
export class ImageUploaderComponent implements ControlValueAccessor {
  @Input() isEditable!: boolean;
  public reader: FileReader = new FileReader(); // file reader
  public photoSrc: SafeResourceUrl | string | ArrayBuffer | null =
    'assets/images/logo.jpg';

  constructor(
    private sanitizer: DomSanitizer,
    private fileManagerService: FileManagerService
  ) {}

  handleFileInput(event: Event) {
    const fileToUpload = this.fileManagerService.handleFileInput(
      event,
      [FileTypes.jpeg, FileTypes.png],
      MAX_FILE_SIZE
    );
    if (!fileToUpload) return;
    this.reader.readAsDataURL(fileToUpload);
    this.photoSrc = this.getImageUrl(fileToUpload);

    this.onChange(fileToUpload);
  }

  getImageUrl(data: File): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      URL.createObjectURL(data)
    );
  }

  onChange: any = () => {
    // function must be empty
  }

  onTouched: any = () => {
    //
  }

  writeValue(value: File): void {
    if (value) this.photoSrc = this.getImageUrl(value);
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
}
